import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

/**
 * Filters Variables down to those that have a classification.
 */
@Pipe({
  name: 'rdsIsClassified',
})
export class IsClassifiedPipe implements PipeTransform {
  transform(variables: Array<Variable | VariableSummary> | null): Array<Variable | VariableSummary> {
    if (!variables) {
      return [];
    }
    // If the variable is not null
    // AND it has a classificationUri OR classificationId
    return variables.filter((v) => !!v && (!!v.classificationUri || !!(v as VariableSummary).classificationId));
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [IsClassifiedPipe],
  declarations: [IsClassifiedPipe],
})
export class RdsIsClassifiedPipeModule {}
